import { useContext } from 'react'
import { AuthContext, type AuthContextValue } from './auth-context'
import { isAuthenticated as checkIsAuthenticated } from '@/api/services/auth.service'

export type { AuthContextValue } from './auth-context'

export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext)

  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider')
  }

  return context
}

export { checkIsAuthenticated as isAuthenticatedCheck }
